function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.9263 9.24317C49.1461 7.43439 48.0211 5.79529 46.6143 4.41763C45.2064 3.03585 43.5465 1.93778 41.7248 1.18311C39.8358 0.397467 37.8098 -0.00467277 35.7644 4.09639e-05C32.8947 4.09639e-05 30.0949 0.786814 27.6618 2.27294C27.0798 2.62845 26.5268 3.01892 26.0029 3.44436C25.479 3.01892 24.9261 2.62845 24.344 2.27294C21.9109 0.786814 19.1111 4.09639e-05 16.2415 4.09639e-05C14.1751 4.09639e-05 12.1728 0.396342 10.281 1.18311C8.45329 1.94075 6.80601 3.03058 5.39156 4.41763C3.98291 5.79374 2.85765 7.43322 2.07954 9.24317C1.27045 11.1256 0.857178 13.1246 0.857178 15.1818C0.857178 17.1226 1.25299 19.1449 2.03879 21.2021C2.69654 22.9214 3.63951 24.7047 4.84441 26.5056C6.75362 29.3554 9.37879 32.3277 12.6384 35.3407C18.0401 40.3353 23.3894 43.7854 23.6164 43.9253L24.9959 44.8111C25.6071 45.2016 26.3929 45.2016 27.0041 44.8111L28.3836 43.9253C28.6106 43.7796 33.9541 40.3353 39.3616 35.3407C42.6212 32.3277 45.2464 29.3554 47.1556 26.5056C48.3605 24.7047 49.3093 22.9214 49.9612 21.2021C50.747 19.1449 51.1428 17.1226 51.1428 15.1818C51.1487 13.1246 50.7354 11.1256 49.9263 9.24317Z",
  fill: "#EF5DA8"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.408 31.5174C20.7525 28.7585 25.3285 25.7041 27.838 24.3247C30.1014 23.0438 31.0363 21.3195 31.0855 18.6592C31.0855 17.3783 30.9379 14.9643 30.3966 13.9297C30.3966 15.4076 29.1173 16.7871 28.084 17.7231C26.0666 19.5952 22.2286 20.4327 20.2112 24.8173C19.4239 26.4923 19.2271 29.9902 20.408 31.5174Z",
  fill: "#74D6D6"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.2109 18.2636C21.1458 16.1452 22.0315 14.5687 23.9997 13.2385C25.9187 11.9576 28.0837 11.2186 30.1503 12.5981C30.0519 11.5142 28.6742 9.69141 26.952 9.69141C25.6727 9.69141 24.6886 9.93773 23.7045 10.5782C21.195 12.1054 20.2109 15.0121 20.2109 18.2636Z",
  fill: "#74D6D6"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.0808 16.048C23.4585 15.2105 27.2473 13.0921 29.5108 13.0921C29.1663 12.5994 28.4283 12.4023 27.7394 12.4023C25.1807 12.4023 22.5237 15.2598 22.0808 16.048Z",
  fill: "white"
});
function SvgFavorit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 46,
    viewBox: "0 0 52 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorit);
export default __webpack_public_path__ + "static/media/favorit.938ea6e4.svg";
export { ForwardRef as ReactComponent };